<template>
  <section v-if="RentalCar && lang[6]">
    <Title :title-name="title.RentalCar.titleName" :title-link="title.RentalCar.titleLink" />
    <div class="rental-car">
      <section class="page-rental-car">
        <div class="container">
          <div class="row" style="margin-top: 14pt">
            <div class="col-12 text-center">
              <img :src="RentalCar.pickUp.logo" />
            </div>
            <div class="col-12">
              <p v-html="replaceStr(lang[6].SFS_LANG_ROW_13, ['<rental_company_name>'], [RentalCar.pickUp.company])"></p>
              <p>
                {{ lang[6].SFS_LANG_ROW_14 }}:
                <span>{{ RentalCar.pickUp.locationname }}</span>
              </p>
              <p>
                {{ lang[6].SFS_LANG_ROW_16 }}:
                <span> {{ RentalCar.pickUp.address }}</span>
              </p>
              <p>
                {{ lang[6].SFS_LANG_ROW_15 }}:
                <span>{{ RentalCar.dropOff.locationname }}</span>
              </p>
              <p>
                {{ lang[6].SFS_LANG_ROW_16 }}:
                <span>{{ RentalCar.dropOff.address }}</span>
              </p>
            </div>
          </div>
          <div style="margin-top: 20px">
            <p>
              <strong>{{ lang[6].SFS_LANG_ROW_17 }}:</strong>
            </p>
            <p v-html="replaceStr(lang[6].SFS_LANG_ROW_18, ['<rental_company_name>'], [RentalCar.pickUp.company])"></p>
          </div>
          <div style="margin-top: 20px">
            <p>
              <strong>{{ lang[6].SFS_LANG_ROW_19 }}:</strong>
            </p>
            <p>{{ lang[6].SFS_LANG_ROW_20 }}</p>
          </div>
        </div>
        <ButtonDownloadVoucher :name-voucher="nameVoucher" :can-download="canDownload"></ButtonDownloadVoucher>
      </section>
    </div>
  </section>
</template>

<script>
import ButtonDownloadVoucher from '@/components/ButtonDownloadVoucher/index'
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import Title from '@/components/Title/index'

export default {
  name: 'RentalCar',
  components: { ButtonDownloadVoucher, Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nameVoucher: 'RentalCar',
      canDownload: false
    }
  },
  computed: {
    ...mapGetters({
      RentalCar: 'RentalCar/RentalCar'
    })
  },
  watch: {
    RentalCar: function (newVal) {
      this.canDownload = newVal && newVal.pickUp.company != '' ? true : false
    }
  },
  mounted() {
    this.$store.dispatch('RentalCar/getRentalCar')
  },
  methods: {
    replaceStr
  }
}
</script>
